<template>
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.0184 3.6145H5.7856C4.00017 3.6145 2.5528 5.06188 2.5528 6.84731V13.8517C2.5528 15.6371 4.00017 17.0845 5.7856 17.0845H9.0184" stroke="currentColor" stroke-width="2.1552"/><path d="M6.86279 7.92499V13.313C6.86279 13.6106 7.10402 13.8518 7.40159 13.8518H11.712C12.0096 13.8518 12.2508 14.093 12.2508 14.3906V17.4002C12.2508 17.8802 12.8312 18.1206 13.1706 17.7812L19.9518 11C20.1622 10.7896 20.1622 10.4484 19.9518 10.238L13.1706 3.45678C12.8312 3.11735 12.2508 3.35775 12.2508 3.83777V6.84739C12.2508 7.14496 12.0096 7.38619 11.712 7.38619H7.40159C7.10402 7.38619 6.86279 7.62742 6.86279 7.92499Z" fill="currentColor"/></svg>
</template>

<script>
export default {
  name: 'ArrowLogout'
}
</script>
